import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const useNavLinks = () => {
  const { pathname } = useLocation();
  const sectionLink = (hash) => (pathname === '/' ? `#${hash}` : `/#${hash}`);

  return [
    { label: 'Services', to: sectionLink('services'), type: 'anchor' },
    { label: 'Process', to: sectionLink('process'), type: 'anchor' },
    { label: 'About Us', to: '/about', type: 'route' },
    { label: 'Contact', to: sectionLink('contact'), type: 'anchor' },
  ];
};

const NavItem = ({ link, onClick, className }) => {
  const testid = `nav-${link.label.toLowerCase().replace(' ', '-')}`;
  if (link.type === 'route') {
    return (
      <Link to={link.to} onClick={onClick} data-testid={testid} className={className}>
        {link.label}
      </Link>
    );
  }
  return (
    <a href={link.to} onClick={onClick} data-testid={testid} className={className}>
      {link.label}
    </a>
  );
};

const Logo = () => (
  <Link to="/" className="flex items-center space-x-3" data-testid="header-home-link">
    <img
      src="/dgd-logo.png"
      alt="Daily Grind Design Logo"
      className="w-24 h-24 md:w-44 md:h-44 object-contain -my-4 md:-my-8"
    />
    <div className="text-xl md:text-2xl font-bold bg-gradient-to-r from-red-600 to-black bg-clip-text text-transparent" style={{ fontFamily: 'Bree Serif, serif' }}>
      Daily Grind Design
    </div>
  </Link>
);

const DesktopNav = ({ links }) => (
  <div className="hidden md:flex space-x-8">
    {links.map((link) => (
      <NavItem key={link.label} link={link} className="text-gray-700 hover:text-red-600 transition-colors" />
    ))}
  </div>
);

const MobileMenu = ({ links, onItemClick }) => (
  <div className="md:hidden mt-4 pb-4">
    {links.map((link) => (
      <NavItem key={link.label} link={link} onClick={onItemClick} className="block py-2 text-gray-700 hover:text-red-600 transition-colors" />
    ))}
  </div>
);

const MenuToggle = ({ isOpen, onToggle }) => (
  <button className="md:hidden" aria-label="Toggle menu" onClick={onToggle}>
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} />
    </svg>
  </button>
);

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const links = useNavLinks();
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="fixed top-0 w-full bg-white/90 backdrop-blur-md z-50 shadow-sm">
      <div className="container mx-auto px-6 py-1">
        <div className="flex items-center justify-between">
          <Logo />
          <DesktopNav links={links} />
          <MenuToggle isOpen={isMenuOpen} onToggle={() => setIsMenuOpen(!isMenuOpen)} />
        </div>
        {isMenuOpen && <MobileMenu links={links} onItemClick={closeMenu} />}
      </div>
    </nav>
  );
};

export default Header;
